import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PrlMarketingToolsComponent} from "./components/prl-marketing-tools/prl-marketing-tools.component";
import {prlAuthentificationGuard} from "../../shared/services/prl-authentification-guard";
import {PrlPageGuard} from '../../shared/services/prl-page.guard';

const routes: Routes = [
    {
        path: 'marketing-tools',
        component: PrlMarketingToolsComponent,
        canActivate: [prlAuthentificationGuard, PrlPageGuard],
        data: {pageName: 'Marketing Tools'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PrlMarketingToolsRoutingModule {
}
